export const fetchOrganizationConfigurationStart = (state, payload) => {
    return {
        ...state,
        fetchOrganizationConfigurationsApi: {
            ...state.fetchOrganizationConfigurationsApi,
            isProcessing: true,
            error: false,
        }


    };
};

export const fetchOrganizationConfigurationSuccess = (state, payload) => {
    return {
        ...state,
        fetchOrganizationConfigurationsApi: {
            ...state.fetchOrganizationConfigurationsApi,
            isProcessing: false,
            error: false,
        },
        isOrgDetailsFetched: true

    };
};

export const fetchOrganizationConfigurationFail = (state, payload) => {
    return {
        ...state,
        fetchOrganizationConfigurationsApi: {
            ...state.fetchOrganizationConfigurationsApi,
            isProcessing: false,
            error: true,
        },
        isOrgDetailsFetched: false

    };
};
